import { useUiLabels } from "../labels/LabelsContext";
import CTA from "../CTA";
import "./styles/index.scss";

// Presentational cookie banner: the app decides when to show it and what the actions do.
const CookieBar = ({ onAccept, onDeny, onMore, onSettings }) => {
  const [getLabel] = useUiLabels();

  return (
    <div className="cookie_wrapper">
      <div className="cookie_content">
        <p>{getLabel("cookie_text")}</p>
        <div className="buttons">
          <CTA customClassName={"dialog"} onClick={onAccept}>
            {getLabel("cookie_buttonAccept")}
          </CTA>
          <CTA customClassName={"dialog"} onClick={onDeny}>
            {getLabel("cookie_buttonDeny")}
          </CTA>
          <CTA customClassName={"dialog"} onClick={onMore}>
            {getLabel("cookie_buttonMore")}
          </CTA>
          <CTA customClassName={"dialog"} onClick={onSettings}>
            {getLabel("cookie_buttonSettings")}
          </CTA>
        </div>
      </div>
    </div>
  );
};

export default CookieBar;
